/**
 * Validate a "?from=" redirect target. Returns "/" for any input that could
 * be used as an open-redirect vector (external URLs, protocol-relative URLs)
 * or that would loop back to the login screen itself.
 */
export function sanitizeFrom(from: string | null): string {
  if (from === null || from === '') return '/';

  let decoded: string;
  try {
    decoded = decodeURIComponent(from);
  } catch {
    return '/';
  }

  if (!decoded.startsWith('/')) return '/';
  if (decoded.startsWith('//')) return '/';
  if (decoded === '/login') return '/';
  if (decoded.startsWith('/login?')) return '/';
  if (decoded.startsWith('/login/')) return '/';
  return decoded;
}
